var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-canvas",style:({width: _vm.cssSize(_vm.width), height: _vm.cssSize(_vm.height)})},[_c('canvas',{ref:"canvas",attrs:{"role":"img","aria-label":_vm.options.plugins && _vm.options.plugins.title && _vm.options.plugins.title.text || 'Diagram'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }